import { Link } from "react-router-dom";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-[#1B2A41]/10 bg-[#F4F1EA]"
        >
            <div
                data-testid="footer-inner"
                className="max-w-[1440px] mx-auto px-6 sm:px-10 lg:px-16 pt-10 pb-16 sm:pb-10"
            >
                <div className="text-[11px] tracking-[0.32em] uppercase font-semibold text-[#1B2A41]/70 leading-tight">
                    Внутри · Елена Кулакова
                    <span className="text-[#1B2A41]/45">
                        {" "}
                        · © {new Date().getFullYear()}
                    </span>
                </div>

                <div
                    data-testid="footer-legal"
                    className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 text-[11px] leading-relaxed text-[#1B2A41]/45"
                >
                    <span data-testid="footer-legal-name">
                        ИП Кулакова Елена Васильевна
                    </span>
                    <span
                        aria-hidden="true"
                        className="hidden sm:inline-block w-1 h-1 bg-[#1B2A41]/20"
                    />
                    <span data-testid="footer-legal-inn">
                        ИНН&nbsp;540725616854
                    </span>
                    <span
                        aria-hidden="true"
                        className="hidden sm:inline-block w-1 h-1 bg-[#1B2A41]/20"
                    />
                    <span data-testid="footer-legal-ogrnip">
                        ОГРНИП&nbsp;325547600112119
                    </span>
                    <span
                        aria-hidden="true"
                        className="hidden sm:inline-block w-1 h-1 bg-[#1B2A41]/20"
                    />
                    <Link
                        to="/privacy"
                        data-testid="footer-privacy-link"
                        className="vnutri-link hover:text-[#1B2A41]"
                    >
                        Политика конфиденциальности
                    </Link>
                </div>
            </div>
        </footer>
    );
};
